/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

const engagementColors = {
  never: '#FF708B',
  nothing: '#c3c3c3',
  little: '#FFBA6A',
  medium: '#7517FB',
  engaged: '#01E4D7',
};

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.name'),
      field: 'fullName',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.fullName}>
          {rowData.fullName}
        </span>
      ),
    },
    {
      title: t('general.cpf'),
      field: 'formattedCpf',
      cellStyle: {
        whiteSpace: 'nowrap',
      },
    },
    { title: t('general.gender'), field: 'gender' },
    {
      title: t('general.phones'),
      field: 'phones',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.phones}>
          {rowData.phones}
        </span>
      ),
    },
    {
      title: t('general.email'),
      field: 'email',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.email}>
          {rowData.email}
        </span>
      ),
    },

    {
      title: t('general.engagement'),
      field: 'engagementStatusInFormat',
      render: (rowData) => (
        <div
          style={{
            backgroundColor: engagementColors[rowData.engagementStatus],
            color: '#ffff',
            textAlign: 'center',
            borderRadius: '5px',
          }}
        >
          <span>{rowData.engagementStatusInFormat}</span>
        </div>
      ),
    },
    {
      title: t('general.last-access'),
      field: 'lastAccessDateInFormat',
      cellStyle: {
        whiteSpace: 'nowrap',
      },
    },
    { title: t('general.last-access-by'), field: 'lastAccessBy' },

    {
      title: t('general.responsibilities'),
      field: 'responsibilities',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.responsibilities}>
          {rowData.responsibilities}
        </span>
      ),
    },
  ];
}
